import styled from "styled-components";

interface ContainerProps {
    $isDragging?: boolean;
    $isFormOpen?: boolean;
}

export const Container = styled.div<ContainerProps>`
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgb(0,0,0, 0.2);
    z-index: 1000;
    
    display: flex;
    align-items: center;
    justify-content: center;


    pointer-events: none; // This allows clicks to pass through to elements below
  
    & > * {
        pointer-events: auto; // But content inside the container will still receive clicks
    }
`;

export const Main = styled.div``;

export const ContentButtonPopUp = styled.div`
`;

export const ContentInfor = styled.div`
    padding: 8px 10px;
`;

export const Title = styled.p`
    background-color: ${(props) => props.theme.colors.white};
    color: ${(props) => props.theme.colors.primary};
    box-shadow: 1px 1px 4px 0px ${(props) => props.theme.colors.gray.gray_100};
    border-radius: 100%;
    width: 30px;
    height: 30px;
    padding: 4px 4px;

    position: absolute;
    top: -10px;
    left: -10px;
    font-size: 18px;

    display: flex;
    align-items: center;
    justify-content: center;
`;

export const ButtonPopUp = styled.button`
    background-color: ${(props) => props.theme.colors.white};
    color: ${(props) => props.theme.colors.primary};
    box-shadow: 1px 1px 4px 0px ${(props) => props.theme.colors.gray.gray_500};
    border-radius: 30px;

    display: flex;
    align-items: center;
    justify-content: center;

    position: fixed;
    bottom: 104px;
    right: 20px;

    width: 56px;
    height: 56px;

    &:hover{
        background-color: ${(props) => props.theme.colors.gray.gray_100};
    }
`;

export const Button = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;

    padding: 8px 12px;
    border-radius: 4px;
    
    box-shadow: rgba(0, 0, 0, 0.2) 0px 1px 1px;
    background-color: ${(props) => props.theme.colors.gray.gray_100};
    color: ${(props) => props.theme.colors.white};
    
    font-size: 14px;
    font-weight: 500;

    &:hover{
        background-color: ${(props) => props.theme.colors.primary};
    }
`;

export const ContentCard = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
`;

export const CloseButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    color: ${(props) => props.theme.colors.gray.gray_600};
    display: flex;
    align-items: center;
    justify-content: center;
    
    &:hover {
        background-color: ${(props) => props.theme.colors.gray.gray_100};
        color: ${(props) => props.theme.colors.gray.gray_800};
    }
`;

export const FormContainer = styled.div`
    position: absolute;

    background-color: ${(props) => props.theme.colors.gray.gray_50};
    width: 90%;
    padding: 30px;
    border-radius: 4px;

    display: flex;
    flex-direction: column;
    gap: 20px;

    &:active {
        cursor: grabbing;
    }

    @media (max-width: 900px) {
        position: static;
        padding: 20px;
        width: 100%;
        max-width: 95%;
        height: 90%;
        max-height: 95%;
    }
`;

export const FormHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const InforErro = styled.div`
    color: ${(props) => props.theme.colors.primary};
    font-size: 12px;
`;

export const ContentBloc = styled.div``;

export const ContentButton = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;

    svg{
        cursor: pointer;
    }

    @media (max-width: 900px) {
        font-size: 12px;
    }
`;

export const ContentInput = styled.div`
    display: flex;
    align-items: center;
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};

    padding: 0px 10px;
`;

export const FormTitle = styled.h3`
    font-size: 24px;
    color: ${(props) => props.theme.colors.gray.gray_800};
    font-weight: 500;
`;

export const FormSubTitle = styled.p`
    color: ${(props) => props.theme.colors.gray.gray_500};
    font-size: 14px;
`;

export const Input = styled.input`
    &::placeholder{
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
    padding: 10px;
    width: 100%;
    
    &.input-border-none{
        border: none;
        padding: 10px 0px;
    }
`;

export const ContentForms = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    overflow-y: scroll;
    height: 470px;

    /* teste */
    width: 70%;

    &::-webkit-scrollbar { 
        width: 5px;
        background-color: ${(props) => props.theme.colors.gray.gray_50};
        display: none;
    }
    &::-webkit-scrollbar-thumb{
        background-color: ${(props) => props.theme.colors.gray.gray_100};
        border-radius: 20px;
        display: none;
    }

    @media (max-width: 780px) {
        height: 275px;
        width: 100%;
    }
`;

export const CancelButton = styled.button`
    flex: 1;
    padding: 12px 16px;
    border: 1px solid ${(props) => props.theme.colors.gray.gray_500};
    background-color: ${(props) => props.theme.colors.white};
    color: ${(props) => props.theme.colors.gray.gray_800};
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    height: 100%;
    
    &:hover {
        background-color: ${(props) => props.theme.colors.gray.gray_50};
        border-color: ${(props) => props.theme.colors.gray.gray_500};
    }
    
    &:active {
        transform: scale(0.98);
    }

    @media (max-width: 900px) {
        font-size: 12px;
    }
`;

export const Form = styled.form`
    height: 100%;
    display: flex;
    justify-content: space-between;
    gap: 10px;
    
    @media (max-width: 780px) {
        flex-direction: column;
        width: 100%;
    }
`;

export const FormActions = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 4px;
    font-size: 14px;

    background-color: ${(props) => props.theme.colors.white};
    border: 1px solid ${(props) => props.theme.colors.gray.gray_50};
    padding: 4px;
    border-radius: 4px;
    
    width: 30%;
    
    @media (max-width: 780px) {
        box-shadow: 0px -4px 4px 0px ${(props) => props.theme.colors.gray.gray_100};
        width: 100%;
    }
`;

export const FormField = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
    width: 100%;
`;

export const Infor = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    border-bottom: 1px dashed ${(props) => props.theme.colors.gray.gray_100};
`;

export const InforText = styled.p`
    color: ${(props) => props.theme.colors.gray.gray_800};
    font-weight: 500;
    &.infor-subtitle{
        font-weight: normal;
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
`;

export const Label = styled.label`
    color: ${(props) => props.theme.colors.gray.gray_800};
    font-size: 14px;
    
    span{
        color: ${(props) => props.theme.colors.primary};
        margin-left: 3px;
    }
`;

export const Section = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    width: 100%;

    &.section-col{
        flex-direction: column;
    }
`;

export const Select = styled.select`
    background-color: transparent;
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
    padding: 8px 10px;

    width: 100%;
`;

export const SubmitButton = styled.button`
    flex: 1;
    padding: 12px 16px;
    border: none;
    background-color: ${(props) => props.theme.colors.primary};
    color: ${(props) => props.theme.colors.white};
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    word-wrap: nowrap;
    
    p{
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
    }
    
    &:hover {
        background-color: ${(props) => props.theme.colors.red.red_800};
    }
    
    &:active {
        transform: scale(0.98);
    }

    @media (max-width: 900px) {
        font-size: 12px;
    }
`;